import { axios } from '@src/plugins/axios-pol'

export default class ResultadoPersonalC3ApiRepository {
  // Recupera todos los resultados C3 de un personal
  async getAll(idPersonal) {
    const { data } = await axios.get(`/personal/api/EstadoFuerza/personal/${idPersonal}/resultadosPersonalesC3`)
    return data.data
  }

  // Recupera un resultado C3 en especifico de un personal
  async getById(idPersonal, idResultado) {
    const { data } = await axios.get(
      `/personal/api/EstadoFuerza/personal/${idPersonal}/resultadosPersonalesC3/${idResultado}`
    )
    return data.data
  }

  //Crea un resultados C3 para un personal
  async create(idPersonal, resultado) {
    const { data } = await axios.post(
      `/personal/api/EstadoFuerza/personal/${idPersonal}/resultadosPersonalesC3`,
      resultado
    )
    return data.data
  }

  //Actualiza un  resultado C3 en especifico de un personal
  async update(idPersonal, idResultado, resultado) {
    const { data } = await axios.put(
      `/personal/api/EstadoFuerza/personal/${idPersonal}/resultadosPersonalesC3/${idResultado}`,
      resultado
    )
    return data.data
  }
}
